import React from 'react';

const Curve=(props)=>(
    <svg className={props.cname} height={props.height} viewBox="0 0 500 300" preserveAspectRatio="none">
        <path d="M0,0 L0,150 Q250,300 500,150 L500,0 Z" fill={props.color} />
    </svg>
);

export default Curve;